import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_jewelry: FaireCategoryEntity = {
  token: "cat_jewelry",
  type: "category",
  name: "Jewelry",
  level: 1,
  href: "/category/jewelry",
  childCategoryTokens: [
    "cat_jewelry-all",
    "cat_jewelry-new-products",
    "cat_jewelry-new-brands",
    "cat_jewelry-bestsellers",
    "cat_jewelry-necklaces",
    "cat_jewelry-earrings",
    "cat_jewelry-bracelets",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
